import React from 'react';
import { useSelector } from 'react-redux';
import { toCSSColor } from '@printu/geom';
import { getViewportVirtualSizeToCanvas, getViewportVirtualToCanvas, } from '@printu/viewport';
import { getItemBounds } from 'app/core/markers/bounds';
import { getProjectState } from 'app/stores/project';
import { LockedPin } from 'app/views/components/editor/platform/desktop/workspace/imageAnnotate/LockedPin';
import { useConnect } from 'app/views/hooks/useConnect';
import { toPx } from 'app/utils/DOM';
const CommonStyles = {
    position: 'absolute',
    letterSpacing: 'unset',
    wordSpacing: 'unset',
    transformOrigin: 'top left',
    background: 'none',
    userSelect: 'none',
    touchAction: 'none',
    border: '1px solid',
};
const SolidBorder = {
    position: 'absolute',
    left: '-1px',
    top: '-1px',
    right: '-1px',
    bottom: '-1px',
    border: '1px dashed white',
};
const getBoundsInViewport = (marker, viewport) => {
    const inflateSize = Math.max(10, marker.size);
    const bounds = getItemBounds(marker).inflate(inflateSize, inflateSize);
    const position = getViewportVirtualToCanvas(viewport, bounds.origin);
    const size = getViewportVirtualSizeToCanvas(viewport, bounds.size);
    return { position, size };
};
const ItemHighlight = (props) => {
    const { marker, viewport } = props;
    if (!marker) {
        return null;
    }
    const { locked } = marker;
    const { position, size } = getBoundsInViewport(marker, viewport);
    return (React.createElement("div", { style: Object.assign(Object.assign({}, CommonStyles), { borderColor: toCSSColor(props.color), width: toPx(size.width), height: toPx(size.height), transform: `translate(${toPx(position.x)}, ${toPx(position.y)})` }) },
        React.createElement("span", { style: SolidBorder }),
        locked === true && React.createElement(LockedPin, null)));
};
export const Hover = () => {
    const { hovered, selected } = useConnect(state => {
        const { hovered: hoveredId, selection, markers, } = getProjectState(state);
        return { hovered: markers[hoveredId], selected: markers[selection[0]] };
    });
    const viewport = useSelector((state) => state.viewport);
    if (!hovered && !selected) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ItemHighlight, { marker: hovered, viewport: viewport, color: "#444444" }),
        React.createElement(ItemHighlight, { marker: selected, viewport: viewport, color: "#3399ff" })));
};
